import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6803e5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order__header flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = { class: "order__content mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comment_modal = _resolveComponent("comment-modal")!
  const _component_change_date_modal = _resolveComponent("change-date-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_order_actions_button = _resolveComponent("order-actions-button")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!
  const _component_invoice_document = _resolveComponent("invoice-document")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.comment_state.is_opened)
      ? (_openBlock(), _createBlock(_component_comment_modal, {
          key: 0,
          loading: _ctx.comment_state.is_loading,
          onSubmit: _ctx.sendComment,
          onCancel: _ctx.toggleComment
        }, null, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.change_take_date_state.is_opened)
      ? (_openBlock(), _createBlock(_component_change_date_modal, {
          key: 1,
          "order-id": _ctx.change_take_date_state.orderId,
          loading: _ctx.change_take_date_state.is_loading,
          title: "Смена даты",
          onCancel: _ctx.cancelChangeDate,
          onSubmit: _ctx.changeDate
        }, null, 8, ["order-id", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.confirm_date_state.is_opened)
      ? (_openBlock(), _createBlock(_component_change_date_modal, {
          key: 2,
          "order-id": _ctx.confirm_date_state.orderId,
          loading: _ctx.confirm_date_state.is_loading,
          title: "Подтвердить перенос забора",
          onCancel: _ctx.cancelConfirmDate,
          onSubmit: _ctx.confirmDate
        }, null, 8, ["order-id", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: `Накладные по заказу (№ ${_ctx.getInvoiceNumber})`
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.state.invoices)
          ? (_openBlock(), _createBlock(_component_order_actions_button, {
              key: 0,
              invoices: _ctx.state.invoices.list,
              loading: _ctx.state.invoices_print.is_loading,
              onToggleComment: _ctx.toggleComment,
              onPrint: _ctx.printOrder,
              onDate: _ctx.startChangeDate,
              onDateConfirm: _ctx.startConfirmDate
            }, null, 8, ["invoices", "loading", "onToggleComment", "onPrint", "onDate", "onDateConfirm"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_button, {
          class: "second text small ml-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.invoices.is_failed && !_ctx.state.invoices.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.invoices.is_loading,
            text: "При получении накладных произошла ошибка",
            "error-message": _ctx.state.invoices.failure.error_state.message,
            "error-url": _ctx.state.invoices.failure.error_state.url,
            "error-status": _ctx.state.invoices.failure.error_state.status,
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadInvoices(_ctx.state.invoices.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.invoices.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.invoices.is_loading,
                columns: _ctx.OrdersColumns,
                rows: _ctx.state.invoices.list,
                pagination: "",
                "pagination-current-page": _ctx.state.invoices.pagination.current_page,
                "pagination-limit": _ctx.state.invoices.pagination.limit,
                "pagination-total-items": _ctx.state.invoices.pagination.total_items,
                "pagination-total-pages": _ctx.state.invoices.pagination.total_pages,
                onChangePage: _ctx.loadInvoices
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'invoice_number' && row.id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/invoice/${row.id}`,
                        class: "content__link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.invoice_number || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'created_at')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.created_at)), 1)
                        ], 64))
                      : (column.key === 'weight')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (row.weight)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(Number(row.weight).toFixed(2)), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("-")
                                ], 64))
                          ], 64))
                        : (row.status && column.key === 'status')
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 3,
                              class: _normalizeClass(`small font-bold ${_ctx.getCheapClass(row.status.id)}`)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.status.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : (column.key === 'take_date')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.take_date)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                              ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.invoices_print.list, (invoice, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `invoice-document-${i}`
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (j) => {
          return _createVNode(_component_invoice_document, {
            key: `invoice-document-copy-${j}`,
            invoice: invoice,
            class: _normalizeClass({ 'InvoiceDocument--dotted': !_ctx.isEven(j) }),
            style: _normalizeStyle(_ctx.isEven(j) ? 'padding-top: 6px;' : 'padding-bottom: 10px;')
          }, null, 8, ["invoice", "class", "style"])
        }), 64))
      ]))
    }), 128))
  ]))
}